import { createContext } from "react";

const TourContext = createContext();

export default TourContext;
